<template>
	<div class="flex-1 flex flex-col">
		<div class="flex-1 bg-gray-100 sm:border-r sm:border-l" :class="{'bg-purple-100':isForecast}">
			<template v-for="phase in phases">
				<order-phase-component :job="job" :phase="phase" :key="'phase'+phase.phase_detail.id" @reload="reload" :active-phase="activePhase" v-on:update:activephase="togglePhase($event)"></order-phase-component>
			</template>	

			<div class="bg-white" :class="{'bg-gray-200': showSpecial == area.area_detail.id}" v-for="area in specialareas" :key="'area'+area.area_detail.id">
				<div class="flex items-center justify-between px-2 py-4 text-sm cursor-pointer" :class="{'border-b': showSpecial != area.area_detail.id, 'bg-blue-800 sticky shadow top-0 z-10': showSpecial == area.area_detail.id}" @click="toggleSpecial(area.area_detail.id)">
					<div class="flex-1 flex items-center" :class="{'text-black': showSpecial != area.area_detail.id, 'text-white': showSpecial == area.area_detail.id}">
	                    <chevron-component class="mr-1" :show="showSpecial == area.area_detail.id"></chevron-component>
						<h3 class="flex-1 cursor-pointer">{{area.area_detail.name}}</h3>
					</div>
					<template v-if="showSpecial == area.area_detail.id">
					<div class="w-20 flex-shrink-0 text-center" :class="{'text-white': showSpecial == area.area_detail.id}" v-if="isForecast">allocated</div>
					<div class="w-20 flex-shrink-0 text-center" :class="{'text-white': showSpecial == area.area_detail.id}">stock</div>
					<div class="w-20 flex-shrink-0 text-center" :class="{'text-white': showSpecial == area.area_detail.id}" v-if="isForecast">avail to forecast</div>
					<div class="w-20 flex-shrink-0 text-center" :class="{'text-white': showSpecial == area.area_detail.id}" v-else>forecast</div>
					</template>
					<div class="w-32 px-1 flex items-center justify-end" :class="{'text-white': showSpecial == area.area_detail.id}">
						<!-- <span class="flex p-2 cursor-pointer" v-if="!isForecast && isAdmin" @click.stop="showSpecialOrder(9, null, area.area_detail.id, null, null)">
							<clipboard-icon class="w-4 h-4"></clipboard-icon>
						</span> -->
					</div>
				</div>
				<div class="sm:pl-4" v-show="showSpecial == area.area_detail.id">
					<div class="flex items-center relative text-sm text-gray-800 pl-5 py-1 border-t first:border-t-0" v-for="(product,index) in area.area_products" :key="'areapdt'+index">
						<div class="flex-1">{{ product.name }} <span class="text-sm text-white">{{ product.id }}</span></div>
						<div class="w-20 flex-shrink-0 text-center" v-if="isForecast">{{ product.allocated }}</div>
						<div class="w-20 flex-shrink-0 text-center">{{ (product.allocated - product.used) <= 0 ? 0 : product.stock_qty }}</div>
						<div class="w-20 flex-shrink-0 text-center" v-if="isForecast">{{ product.allocated - product.forecasted }}</div>
						<div class="w-20 flex-shrink-0 text-center" v-else>{{ product.forecasted - product.used }}</div>
						<div class="w-32 text-right">
							<input v-if="(!isForecast && (product.allocated - product.used) > 0 && product.stock_qty>0 && product.pdt_status=='in_stock') || (isForecast && (product.allocated - product.used) > 0)" class="w-12 sm:w-24 text-base appearance-none border rounded py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" type="text" @input="modifySpeciaAreaProductQty(area.area_detail.id, product, $event, 'Specialarea')" placeholder="qty">
							<check-circle-icon class="w-8 h-8 inline-block text-green-400 p-2 mr-2" v-if="(product.allocated - product.used) <= 0 && product.forecasted >0"></check-circle-icon>
							<template v-if="!isForecast">
								<clock-icon class="w-8 h-8 inline-block text-blue-400 p-2 mr-2" v-if="product.stock_qty == 0 && product.forecasted > product.used && product.used < product.allocated"></clock-icon>
								<alert-circle-icon class="w-8 h-8 inline-block text-red-400 p-2 mr-2" v-if="product.forecasted < product.allocated && product.stock_qty == 0"></alert-circle-icon>
							</template>
						</div>
					</div>

				</div>
			</div>
			<div class="bg-white" :class="{'bg-gray-200': showTools}" v-if="job_products.length">
				<div class="flex items-center justify-between px-2 py-4 text-sm cursor-pointer" :class="{'bg-blue-800 sticky top-0 z-10': showTools, 'border-b': !showTools}"  @click="toggleTools">
					<div class="flex-1 flex items-center" :class="{'text-black': !showTools, 'text-white': showTools}">
	                    <chevron-component class="mr-1" :show="showTools"></chevron-component>
						<h3 class="flex-1 cursor-pointer">Tools &amp; Consumables</h3>
					</div>
					<template v-if="showTools">
					<div class="w-20 flex-shrink-0 text-center" :class="{'text-white': showTools}" v-if="isForecast">allocated</div>
					<div class="w-20 flex-shrink-0 text-center" :class="{'text-white': showTools}">stock</div>
					<div class="w-20 flex-shrink-0 text-center" :class="{'text-white': showTools}" v-if="isForecast">avail to forecast</div>
					<div class="w-20 flex-shrink-0 text-center" :class="{'text-white': showTools}" v-else>forecast</div>
					</template>
					<div class="w-32 px-1 flex items-center justify-end" :class="{'text-white': showTools}">
						<!-- <span class="flex p-2 cursor-pointer" v-if="!isForecast && isAdmin" @click.stop="showSpecialOrder(7, null, null, null, null)">
							<clipboard-icon class="w-4 h-4"></clipboard-icon>
						</span> -->
					</div>
				</div>
				<div class="sm:pl-4" v-show="showTools">
					<div class="flex items-center relative text-sm text-gray-800 pl-5 py-1 border-t first:border-t-0" v-for="product in job_products" :key="'jobpdt'+product.id">
						<div class="flex-1">
							{{ product.name }} <span class="text-sm text-gray-200">{{ product.id }}</span>
						</div>
						<span class="w-20 flex-shrink-0 text-center" v-if="isForecast">{{ product.allocated }}</span>
						<span class="w-20 flex-shrink-0 text-center">{{ (product.allocated - product.used) <= 0 ? 0 : product.stock_qty }}</span>
						<span class="w-20 flex-shrink-0 text-center" v-if="isForecast">{{ product.allocated - product.forecasted }}</span>
						<span class="w-20 flex-shrink-0 text-center" v-else>{{ product.forecasted - product.used }}</span>
						<div class="w-32 text-right">
							<input v-if="(!isForecast && (product.allocated - product.used) > 0 && product.stock_qty>0 && product.pdt_status=='in_stock') || (isForecast && (product.allocated - product.forecasted) > 0 && (product.allocated - product.used) > 0)" class="w-12 sm:w-24 text-base appearance-none border rounded py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" type="text" @input="modifyProductQty(product, $event, 'Tools')" placeholder="qty">
							<check-circle-icon class="w-8 h-8 inline-block text-green-400 p-2 mr-2" v-if="(product.allocated - product.used) <= 0 && product.forecasted >0"></check-circle-icon>
							
							<template v-if="!isForecast">
								<clock-icon class="w-8 h-8 inline-block text-blue-400 p-2 mr-2" v-if="product.stock_qty == 0 && product.forecasted > product.used && product.used < product.allocated"></clock-icon>
								<alert-circle-icon class="w-8 h-8 inline-block text-red-400 p-2 mr-2" v-if="product.forecasted < product.allocated && product.stock_qty == 0"></alert-circle-icon>
							</template>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="flex">
			<div class="flex w-full justify-center py-4" :class="orderEmpty ? 'bg-gray-400 cursor-not-allowed' : 'bg-green-600'">
				<action-button class="flex w-full justify-center text-white" @button-clicked="location=='Forecast Order' ? showConfirm = $store.getters['order/getOrder'] : placeOrder()" :disabled="orderEmpty">
					<clipboard-icon class="w-5 h-5 mr-1"></clipboard-icon>
					<span v-html="location=='Forecast Order' ? 'Save Forecast' :'Place Order'"></span>
				</action-button>
			</div>
		</div>
		<portal to="modals" v-if="specialOrder.show" :order="1">
			<special-order-modal
				:show="specialOrder.show"
				:job="job"
				:special-order="specialOrder"
				@close="closeSpecialOrder"
				@save="saveSpecialOrder"
				@reload="$emit('reload')"
				>
			</special-order-modal>
		</portal>
		<portal to="modals" v-if="showConfirm" :order="2">
			<confirm-forecast
				:show="showConfirm"
				:the-object="humanReadableOrder"
				@close="showConfirm = null"
				@confirm="placeOrder"
			>
			</confirm-forecast>
		</portal>
	</div>
</template>

<script>
import SpecialOrderModal from '@/components/common/SpecialOrderModal.vue'
import ConfirmForecast from '@/components/common/ConfirmForecast.vue'
import OrderPhaseComponent from '@/components/orders/OrderPhaseComponent.vue'
import { ClipboardIcon } from 'vue-feather-icons'
export default {
	name: 'NewOrder',
	data () {
		return {
			job: {},
			phases: {},
			specialareas: {},
			job_products: {},
			specialOrder: {
				show: false,
				catId: false,
				phase: false,
				area: false,
				block: false,
				unit: false,
				job: this.$route.params.id
			},
			showTools: false,
			showSpecial: false,
			showConfirm: null,
			forecast:{},
			error: {},
			activePhase: null,
		}
	},
	computed: {
		role: function(){
			return this.$store.getters['auth/role'];
		},
		location: function(){
			return this.$route.name
		},
		isForecast: function(){
			return this.location == 'Forecast Order'
		},
		orderEmpty: function(){
			return this.$store.getters['order/orderEmpty'];
		},
		commentsRequired: function(){
			return this.$store.getters['order/areaOrderCommentsRequired'] || this.$store.getters['order/RetGenOrderCommentsRequired'];
		},
		isAdmin: function(){
			return this.role === 'Super Admin' || this.role === 'Administrator';
		},
		isManager: function(){
			return this.role === 'Regional Manager' || this.role === 'Site Manager';
		},
		humanReadableOrder() {
			let order = this.$store.getters['order/getOrder'];
			let readable = this.$_.reduce(order, (result, value, key) => {
				switch(key){
					case 'area':
						this.$_.forEach(value, (prodArray, area_id) => {
							this.$_.forEach(this.phases, (phaseObject, index) => {
								if(phaseObject.areas){
									phaseObject.areas.forEach((area,areaIndex) => {
										if(area.area_detail.id == area_id){
											let areaName = area.area_detail.name;
											let phaseName = phaseObject.phase_detail.name;
											let products = [];
											prodArray.forEach((prodObj) => {
												let prodId = Object.keys(prodObj)[0];
												let qty = prodObj[prodId];
												let productDetailArray = area.area_products.filter((prod) => {
													return prod.id == prodId;
												});
												let product = {
													id: prodId,
													name: productDetailArray[0].name,
													qty: qty,
												};
												products.push(product);
											});
											result.phases = result.phases || {};
											result.phases[phaseName] = result.phases[phaseName] || {};
											result.phases[phaseName]['areas'] = result.phases[phaseName]['areas'] || [];
											result.phases[phaseName]['areas'].push({
												name: areaName,
												products: products,
											});
										}
									});
								}
							});
						});
					break;
					case 'phase':
						this.$_.forEach(value, (prodArray, phase_id) => {
							this.$_.forEach(this.phases, (phaseObject, index) => {
								if(phaseObject.phase_detail.id == phase_id){
									let phaseName = phaseObject.phase_detail.name;
									let products = [];
									prodArray.forEach((prodObj) => {
										let prodId = Object.keys(prodObj)[0];
										let qty = prodObj[prodId];
										let productDetailArray = phaseObject.ret_gen.filter((prod) => {
											return prod.id == prodId;
										});
										let product = {
											id: prodId,
											name: productDetailArray[0].name,
											qty: qty,
										};
										products.push(product);
									});
									result.phases = result.phases || {};
									result.phases[phaseName] = result.phases[phaseName] || {};
									result.phases[phaseName]['products'] = result.phases[phaseName]['products'] || products;
								}
							});
						});
					break;
					case 'carports':
						this.$_.forEach(value, (prodArray, phase_id) => {
							this.$_.forEach(this.phases, (phaseObject, index) => {
								if(phaseObject.phase_detail.id == phase_id){
									let phaseName = phaseObject.phase_detail.name;
									let products = [];
									prodArray.forEach((prodObj) => {
										let prodId = Object.keys(prodObj)[0];
										let qty = prodObj[prodId];
										let productDetailArray = phaseObject.carports.filter((prod) => {
											return prod.id == prodId;
										});
										let product = {
											id: prodId,
											name: productDetailArray[0].name,
											qty: qty,
										};
										products.push(product);
									});
									result.phases = result.phases || {};
									result.phases[phaseName] = result.phases[phaseName] || {};
									result.phases[phaseName]['carports'] = products;
								}
							});
						});
					break;
					case 'first_fix':
					case 'wire':
					case 'common':
						this.$_.forEach(value, (prodArray, block_id) => {
							this.$_.forEach(this.phases, (phaseObject, index) => {
								phaseObject.blocks.forEach((block) => {
									if(block.block_detail.id == block_id){
										let blockName = block.block_detail.name;
										let phaseName = phaseObject.phase_detail.name;
										let products = [];
										prodArray.forEach((prodObj) => {
											let prodId = Object.keys(prodObj)[0];
											let qty = prodObj[prodId];
											let floor = prodObj['floor'];
											let productDetailArray = block.block_products.filter((prod) => {
												return prod.id == prodId;
											});
											let product = {
												id: prodId,
												name: productDetailArray[0].name,
												qty: qty,
												floor: floor,
											};
											products.push(product);
										});
										result.phases = result.phases || {};
										result.phases[phaseName] = result.phases[phaseName] || {};
										result.phases[phaseName]['blocks'] = result.phases[phaseName]['blocks'] || {};
										result.phases[phaseName]['blocks'][blockName] = result.phases[phaseName]['blocks'][blockName] || {};
										result.phases[phaseName]['blocks'][blockName][key] = result.phases[phaseName]['blocks'][blockName][key] || products;
									}
								});
							});
						});
					break;
					case 'tools':
						this.$_.forEach(value, (prodArray, job_id) => {

							result.tools = result.tools || [];
							let products = [];
							prodArray.forEach((prodObj) => {
								let prodId = Object.keys(prodObj)[0];
								let qty = prodObj[prodId];
								let productDetailArray = this.job_products.filter((prod) => {
									return prod.id == prodId;
								});
								let product = {
									id: prodId,
									name: productDetailArray[0].name,
									qty: qty,
								};
								products.push(product);
							});
							result.tools = products;
						});
					break;
					case 'units':
						this.$_.forEach(value, (prodObject, unit_id) => {
							this.$_.forEach(this.phases, (phaseObject, index) => {
								phaseObject.blocks.forEach((block) => {
									if(block.units){
										block.units.forEach((unit) => {
											if(unit.id == unit_id){
												let blockName = block.block_detail.name;
												console.log(blockName);
												let phaseName = phaseObject.phase_detail.name;
												let unitName = unit.name;
												let products = prodObject;
												
												result.phases = result.phases || {};
												result.phases[phaseName] = result.phases[phaseName] || {};
												result.phases[phaseName]['blocks'] = result.phases[phaseName]['blocks'] || {};
												result.phases[phaseName]['blocks'][blockName] = result.phases[phaseName]['blocks'][blockName] || {};
												result.phases[phaseName]['blocks'][blockName]['units'] = result.phases[phaseName]['blocks'][blockName]['units'] || [];
												result.phases[phaseName]['blocks'][blockName]['units'].push({
													name: unitName,
													products: products,
												});
											}
										});
									}
								});
							});
						});
					break;
				}
				return result;
			}, {});
			return readable;
		}
	},
	methods: {
		togglePhase: function(newVal){
			this.activePhase = newVal;
			this.showSpecial = false;
			this.showTools = false;
		},
		toggleSpecial: function(areaid){
			this.activePhase = null;
			this.showTools = false;
			if(this.showSpecial == areaid){
				this.showSpecial = false;
				return;
			}
			this.showSpecial = areaid;
		},
		toggleTools: function(){
			this.activePhase = null;
			this.showSpecial = false,
			this.showTools = !this.showTools;
		},
		reload: function () {
			var jobId = this.$route.params.id
			this.$http.get(`jobs/${jobId}`)
				.then(response => {
					this.job = response.data.jobdetails
					this.phases = response.data.phases
					this.specialareas = response.data.specialareas
					this.job_products = response.data.job_products
					this.$store.commit('setJobName', this.job.name)
				})
				.catch(err => {
					this.error = err
				})
				.finally(() => {
					this.$store.commit('forecast/emptyStore');
					this.$store.commit('order/emptyStore');
				});
		},
		splitCategory: function (job_products, howMany) {
			var chunckSize = Math.ceil(job_products.length / howMany);
			return this.$_.chunk(job_products, chunckSize);
		},
		showSpecialOrder: function(catId, phase, area, block, unit){
			this.specialOrder.show = true;
			this.specialOrder.catId = catId;
			this.specialOrder.phase = phase;
			this.specialOrder.area = area;
			this.specialOrder.block = block;
			this.specialOrder.unit = unit;
		},
		closeSpecialOrder: function(){
			this.specialOrder.show = false;
			this.specialOrder.phase = false;
			this.specialOrder.area = false;
			this.specialOrder.block = false;
			this.specialOrder.unit = false;
		},
		saveSpecialOrder: function(){
			console.log('http');
		},
		modifyProductQty: function(product, event, type){
			if(this.isForecast){
				if(event.target.value > (product.allocated - product.forecasted)){
					event.target.value = product.allocated - product.forecasted;
				}
			}else{
				if(event.target.value > (product.allocated - product.used)){
					event.target.value = product.allocated;
				}
			}
			this.$nextTick(function () {
				this.$store.commit('order/modifyProductQty', {
					'jobId': this.$route.params.id,
					'productId': product.id,
					'qty': event.target.value,
					'type': type
				});				
			})
		},
		modifySpeciaAreaProductQty: function(areaid, product, event, type){
			if(event.target.value > (product.allocated - product.used)){
				event.target.value = product.allocated;
			}
			this.$nextTick(function () {
				this.$store.commit('order/modifyProductQty', {
					'areaId': areaid,
					'productId': product.id,
					'qty': event.target.value,
					'type': type
				});				
			})
		},
		placeOrder(){
			var order = this.$store.getters['order/getOrder']
			var placed_by = this.$store.getters['auth/userid']
			
			if(this.$route.name === 'Create Order'){
				if(!this.orderEmpty) {
					this.$http.post(`jobs/${this.$route.params.id}/orders/`, {'order':order,'placed_by':placed_by})
					.then(response => {
						if(response.data.success == false){
							let error = {
								title: response.data.msg,
								type: 'error'
							}
							this.$store.commit('setStatus', error);
							return;
						}
						// if(response.data.errors){
						// 	let error = {
						// 		title: '',
						// 		message: '',
						// 		type: 'info'
						// 	}
						// 	this.$store.commit('setStatus', error);
						// 	return;
						// }else{
							let success = {
								title: 'Action Successful',
								message: 'Order Placed Successfully!',
								type: 'success'
							}
						//}
						this.$store.commit('order/emptyStore');	
						this.$store.commit('setStatus', success)		
						this.reload();
						this.$emit('reload');
						this.$store.commit('order/emptyStore');
						this.$router.push(`/`);
					})
					.catch(err => {
						console.log(err);
						let error = {
							title: 'Server Error',
							message: 'Please contact Roark, page is new order',
							type: 'error'
						}
						this.$store.commit('setStatus', error);
					})
				} else{
					let err = {
						title: 'No products in order',
						type: 'error'
					}
					this.$store.commit('setStatus', err)
				}
			}
			if(this.$route.name === 'Forecast Order'){
				if(!this.orderEmpty && !this.commentsRequired) {
					this.$http.post(`jobs/${this.$route.params.id}/forecast/`, {'forecast':JSON.parse ( JSON.stringify (order)),'placed_by':placed_by})
						.then(response => {
							let message = 'Forecast submitted Successfully!';
							if(response.data.message){
								message = response.data.message;
							}
							let success = {
								title: 'Action Successful',
								message: message,
								type: 'success'
							}
							this.$store.commit('setStatus', success)
							this.$store.commit('forecast/emptyStore');
							this.$store.commit('order/emptyStore');	
							this.$router.push(`/`);
						})
						.catch(err => {
							let error = {
								title: 'Server Error',
								message: 'Please contact Roark, page is forecast order',
								type: 'error'
							}
							this.$store.commit('setStatus', error);
						})
				} else{
					let err = {
						title: 'No products in forecast or comment required',
						type: 'error'
					}
					this.$store.commit('setStatus', err)
				}
			}
		}
	},
	components: {
		OrderPhaseComponent,
		SpecialOrderModal,
		ClipboardIcon,
		ConfirmForecast
	},
	created: function () {
		this.reload();
	}
}
</script>
